const fundraiser = {
  'living-with-lung-cancer': {
    name: 'Roche Products Limited',
    code: 'RXUKCOMM01860k',
    time: 'September 2018',
    disclaimer: 'The development of this programme is funded by Roche Products Limited, but the content was produced by HealthUnlocked and the Roy Castle Lung Cancer Foundation. Roche reviewed the content for factual accuracy only.',
  },
};

export default fundraiser;



// WEBPACK FOOTER //
// ./src/modules/programs/shared/constants/fundraiser.js